import qs from "query-string";
import { parse, print } from "graphql";
import weaviate from "weaviate-client";
import { getWeaviateScheme, getWeaviateHost } from "../../helperFunctions";

//returns the appropriate header depending on whether it needs authentication or not
export const headerObj = () => {
  const token = JSON.parse(localStorage.getItem("access_token"));
  const isWeaviateAuthenticated = JSON.parse(
    localStorage.getItem("isWeaviateAuthenticated")
  );

  if (isWeaviateAuthenticated === true && token !== "") {
    return {
      "Content-Type": "application/json",
      authorization: `Bearer ${token}`,
    };
  } else {
    return {
      "Content-Type": "application/json",
    };
  }
};

//returns initial query
export const getQuery = () => {
  let drawing = "# \n";
  drawing += "#                           _       _        \n";
  drawing += "#                          (_)     | |       \n";
  drawing += "# __      _____  __ ___   ___  __ _| |_ ___  \n";
  drawing += "# \\ \\ /\\ / / _ \\/ _` \\ \\ / / |/ _` | __/ _ \\ \n";
  drawing += "#  \\ V  V /  __/ (_| |\\ V /| | (_| | ||  __/ \n";
  drawing += "#   \\_/\\_/ \\___|\\__,_| \\_/ |_|\\__,_|\\__\\___| \n";
  drawing += "#                                            \n";
  drawing += "# \n";
  drawing += "# Weaviate GraphQL interface\n";
  drawing += "# More information: weaviate.io\n";
  drawing += "#\n";
  drawing += "# Powered by GraphiQL\n";

  const hashObj = qs.parse(window.location.hash);

  if ("graphql_query" in hashObj && "prettify" in hashObj) {
    return print(parse(hashObj.graphql_query));
  } else if ("graphql_query" in hashObj) {
    return hashObj.graphql_query;
  } else {
    return drawing;
  }
};

// Sets the theme for the Query modal every time it renders
export const setTheme = (state) => {
  let root = document.documentElement;

  if (state.theme === "light") {
    root.style.setProperty("--queryModule-property-string", "#122742");
    root.style.setProperty("--queryModule-value-string", "#fa0171");
    root.style.setProperty("--queryModule-query-variables-color", "#122742");
    root.style.setProperty("--queryModule-number", "#aa5300");
    root.style.setProperty("--queryModule-gutters", "#d0d0d0");
    root.style.setProperty("--queryModule-panelBackground-color", "#586d91");
    root.style.setProperty("--queryModule-panelText-color", "#fff");
    root.style.setProperty(
      "--queryModule-panelHistoryItem-hover-background",
      "#304a6c"
    );
    root.style.setProperty("--queryModule-field-name-color", "#38d611");
    root.style.setProperty("--queryModule-arg-name-color", "#d1d1d1");
    root.style.setProperty("--queryModule-shareQuery-input-color", "#122742");
    root.style.setProperty("--queryModule-searchfield-text-color", "#00152b");
  } else if (state.theme === "dark") {
    root.style.setProperty("--queryModule-property-string", "#38d611");
    root.style.setProperty("--queryModule-value-string", "#fa0171");
    root.style.setProperty("--queryModule-query-variables-color", "#77a4f9");
    root.style.setProperty("--queryModule-number", "#c4b223");
    root.style.setProperty("--queryModule-gutters", "#3d577c");
    root.style.setProperty("--queryModule-panelBackground-color", "#5e5e5e");
    root.style.setProperty("--queryModule-panelText-color", "#f7f7f7");
    root.style.setProperty(
      "--queryModule-panelHistoryItem-hover-background",
      "#2b2b2b"
    );
    root.style.setProperty("--queryModule-panelHistory-text-color", " #f7f7f7");
    root.style.setProperty("--queryModule-panel-title", " #fff");
    root.style.setProperty("--queryModule-field-name-color", "#a5c5ff");
    root.style.setProperty("--queryModule-arg-name-color", "#ff90bd");
    root.style.setProperty("--queryModule-shareQuery-input-color", "#fff");
    root.style.setProperty("--queryModule-searchfield-text-color", "#fff");
  }
};

//updates to new weaviate if user tries to follow a link or change Weaviate
export const updateToNewWeaviateFromURL = (hashObj, state, setState) => {
  setState({
    ...state,
    connectToWeaviateURI: hashObj.weaviate_uri,
    // oidcUri: "",
    // clientId: "",
    isWeaviateAuthenticated: false,
    // isLoggedIn: true,
    // isWeaviateSelfHosted: false,
    // isWeaviateURIDisconnected: false,
  });
  localStorage.setItem(
    "connectToWeaviateURI",
    JSON.stringify(hashObj.weaviate_uri)
  );
  // localStorage.setItem("isWeaviateURIDisconnected", JSON.stringify(false));
  // localStorage.setItem("oidcUri", JSON.stringify(""));
  // localStorage.setItem("clientId", JSON.stringify(""));
  // localStorage.setItem("access_token", JSON.stringify(""));
  // localStorage.setItem("refresh_token", JSON.stringify(""));
  localStorage.setItem("isWeaviateAuthenticated", JSON.stringify(false));
  // localStorage.setItem("isLoggedIn", JSON.stringify(true));
  // localStorage.setItem("isWeaviateSelfHosted", JSON.stringify(false));
  localStorage.setItem("currentModule", JSON.stringify("Query"));
};

// Triggered when the Query module is rendered. It decides how it behaves
export const decisionMaker = (
  state,
  setState,
  hashObj,
  setIsURICheckerModalOpen,
  history
) => {
  setTheme(state);
  if (
    "weaviate_uri" in hashObj &&
    hashObj.weaviate_uri !== state.connectToWeaviateURI &&
    state.connectToWeaviateURI !== ""
  ) {
    setIsURICheckerModalOpen(true);
  } else if ("weaviate_uri" in hashObj && state.connectToWeaviateURI === "") {
    updateToNewWeaviateFromURL(hashObj, state, setState);
  } else if (hashObj.weaviate_uri === undefined && state.connectToWeaviateURI) {
    return;
  } else if (
    hashObj.weaviate_uri === undefined &&
    state.connectToWeaviateURI === ""
  ) {
    history.push("/console/query/weaviate-not-connected");
  }
};

export const getSchema = async (state, setSchema) => {
  try {
    if (state.connectToWeaviateURI === "") {
      return;
    } else {
      const client = weaviate.client({
        scheme: getWeaviateScheme(state.connectToWeaviateURI) || "http",
        host: getWeaviateHost(state.connectToWeaviateURI) || "localhost:8080",
        headers: headerObj(),
      });

      const res = await client.schema.getter().do();

      setSchema(res);
    }
  } catch (err) {
    console.error("ERROR helpers::getSchema::Error", err);
    throw new Error("Unable to fetch schema");
  }
};
